import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface BlackoutDayState {
  totalRecords: number | null;
  data: [] | null | any;
  totalPages: number | null;
  currentPage: number | null;
}

const initialState: BlackoutDayState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
};

export const blackoutDaySlice = createSlice({
  name: 'blackoutday',
  initialState,
  reducers: {
    setBlackoutDay: (state: any, action: any) => {
      state.data = action.payload;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewBlackoutDay: (state: any, action: any) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setBlackoutDay, addNewBlackoutDay, reset } = blackoutDaySlice.actions;
export const getBlackoutDay = (state: RootState) => state.blackoutDay.data;
export const addBlackoutDay = (state: RootState) => state.blackoutDay.data;
export const getBlackoutDayTotalRecord = (state: RootState) => state.blackoutDay.totalRecords;

export default blackoutDaySlice.reducer;
